import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85495422")

_pushScopeId("data-v-85495422")
const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = {
  key: 0,
  class: "container regular-container pb-lg-3",
  style: {"padding-top":"100px"}
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "accounting-document-title" }
const _hoisted_6 = { class: "accounting-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-12 col-lg-7 px-4 px-lg-3 mx-auto" }
const _hoisted_10 = {
  class: "accounting-inline-title-ex w-100",
  style: {"line-height":"20px"}
}
const _hoisted_11 = { class: "accounting-inline-value-ex w-100" }
const _hoisted_12 = { class: "row mt-12" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "col-12 col-lg-7 px-4 px-lg-3 mx-auto" }
const _hoisted_15 = {
  class: "accounting-inline-title-ex w-100",
  style: {"line-height":"20px"}
}
const _hoisted_16 = { class: "accounting-inline-value-ex w-100" }
const _hoisted_17 = { class: "row mt-12" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "accounting-total-round-clock" }
const _hoisted_20 = { class: "col-lg-7 px-4 px-lg-3 mx-auto" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-5" }
const _hoisted_23 = { class: "accounting-inline-title-ex" }
const _hoisted_24 = { class: "accounting-inline-value-ex" }
const _hoisted_25 = { class: "col-3" }
const _hoisted_26 = { class: "accounting-inline-title-ex" }
const _hoisted_27 = { class: "accounting-inline-value-ex rate-value" }
const _hoisted_28 = { class: "col-4 px-0 px-lg-3" }
const _hoisted_29 = { class: "accounting-inline-title-ex" }
const _hoisted_30 = { class: "accounting-inline-value-ex" }
const _hoisted_31 = { class: "row mt-12" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = {
  key: 0,
  class: "accounting-form"
}
const _hoisted_34 = { class: "col-lg-7 px-4 px-lg-3 mx-auto" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = { class: "accounting-inline-title-ex" }
const _hoisted_38 = { class: "accounting-inline-value-ex" }
const _hoisted_39 = { class: "row mt-12" }
const _hoisted_40 = { class: "col-12" }
const _hoisted_41 = { class: "accounting-inline-title-ex" }
const _hoisted_42 = { class: "accounting-inline-value-ex" }
const _hoisted_43 = { class: "row mt-12" }
const _hoisted_44 = { class: "col-7" }
const _hoisted_45 = { class: "accounting-inline-title-ex" }
const _hoisted_46 = { class: "accounting-inline-value-ex" }
const _hoisted_47 = { class: "col-5" }
const _hoisted_48 = { class: "accounting-inline-title-ex" }
const _hoisted_49 = { class: "accounting-inline-value-ex" }
const _hoisted_50 = {
  key: 1,
  class: "accounting-form"
}
const _hoisted_51 = { class: "col-lg-7 px-4 px-lg-3 mx-auto" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-12" }
const _hoisted_54 = { class: "accounting-inline-title-ex" }
const _hoisted_55 = { class: "accounting-inline-value-ex" }
const _hoisted_56 = { class: "row mt-12" }
const _hoisted_57 = { class: "col-6 col-lg-7" }
const _hoisted_58 = { class: "accounting-inline-title-ex" }
const _hoisted_59 = { class: "accounting-inline-value-ex" }
const _hoisted_60 = { class: "col-6 col-lg-5" }
const _hoisted_61 = { class: "accounting-inline-title-ex" }
const _hoisted_62 = { class: "accounting-inline-value-ex" }
const _hoisted_63 = { class: "row mt-12" }
const _hoisted_64 = { class: "col-6 col-lg-7" }
const _hoisted_65 = { class: "accounting-inline-title-ex" }
const _hoisted_66 = { class: "accounting-inline-value-ex" }
const _hoisted_67 = { class: "col-6 col-lg-5" }
const _hoisted_68 = { class: "accounting-inline-title-ex" }
const _hoisted_69 = { class: "accounting-inline-value-ex" }
const _hoisted_70 = { key: 2 }
const _hoisted_71 = { class: "col-lg-7 px-4 px-lg-3 mx-auto" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = { class: "accounting-inline-title-ex" }
const _hoisted_75 = { class: "accounting-inline-value-ex" }
const _hoisted_76 = { class: "row mt-12" }
const _hoisted_77 = { class: "col-6 col-lg-7" }
const _hoisted_78 = { class: "accounting-inline-title-ex" }
const _hoisted_79 = { class: "accounting-inline-value-ex" }
const _hoisted_80 = { class: "col-6 col-lg-5" }
const _hoisted_81 = { class: "accounting-inline-title-ex" }
const _hoisted_82 = { class: "accounting-inline-value-ex" }
const _hoisted_83 = { class: "row mt-12" }
const _hoisted_84 = { class: "col-6 col-lg-7" }
const _hoisted_85 = { class: "accounting-inline-title-ex" }
const _hoisted_86 = { class: "accounting-inline-value-ex" }
const _hoisted_87 = { class: "col-6 col-lg-5" }
const _hoisted_88 = { class: "accounting-inline-title-ex" }
const _hoisted_89 = { class: "accounting-inline-value-ex" }
const _hoisted_90 = { class: "row mt-12" }
const _hoisted_91 = { class: "col-6" }
const _hoisted_92 = { class: "accounting-inline-title-ex" }
const _hoisted_93 = { class: "accounting-inline-value-ex" }
const _hoisted_94 = {
  key: 3,
  style: {"margin-bottom":"25px"},
  class: "col-lg-7 px-lg-3 mx-auto"
}
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-12" }
const _hoisted_97 = { class: "accounting-inline-title-ex" }
const _hoisted_98 = { class: "accounting-inline-value-ex" }
const _hoisted_99 = {
  class: "mt-auto",
  style: {"box-shadow":"0px 0px 12px 2px #d6e0e7"}
}
const _hoisted_100 = { class: "receipt-total-amount-block" }
const _hoisted_101 = { class: "d-flex justify-content-between my-4 col-10 col-md-6 col-lg-5 col-xl-3 mx-auto" }
const _hoisted_102 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  disabled: "",
  class: "accounting-circle-button btn-blue"
}, " Share ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ($setup.receipt)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t('accounting.receipt')) + " #" + _toDisplayString($setup.receipt.documentNumber) + " of ", 1),
                _createVNode(_component_router_link, {
                  to: { name: 'order', params: { id: $setup.receipt.orderId } },
                  class: "text-link"
                }, {
                  default: _withId(() => [
                    _createTextVNode(" Order #" + _toDisplayString($setup.receipt.orderNumber), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('accounting.to')) + ":", 1),
                        _createVNode("div", _hoisted_11, _toDisplayString($setup.receipt.recipientName), 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('accounting.for')) + ":", 1),
                        _createVNode("div", _hoisted_16, _toDisplayString($setup.receipt.for), 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _createVNode("div", _hoisted_22, [
                              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('receipt.amount')) + ":", 1),
                              _createVNode("div", _hoisted_24, _toDisplayString(_ctx.formatAmount($setup.receipt.total)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.receipt.currencyId)), 1)
                            ]),
                            _createVNode("div", _hoisted_25, [
                              _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('receipt.rate')) + ":", 1),
                              _createVNode("div", _hoisted_27, _toDisplayString($setup.receipt.localCurrencyRate), 1)
                            ]),
                            _createVNode("div", _hoisted_28, [
                              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('accounting.total')) + ":", 1),
                              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.formatAmount($setup.receipt.localCurrencyTotalAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.receipt.localCurrencyId)), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, [
                      ($setup.receipt.creditCardPayment)
                        ? (_openBlock(), _createBlock("div", _hoisted_33, [
                            _createVNode("div", _hoisted_34, [
                              _createVNode("div", _hoisted_35, [
                                _createVNode("div", _hoisted_36, [
                                  _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('receiptCreditCard.holderName')) + ":", 1),
                                  _createVNode("div", _hoisted_38, _toDisplayString($setup.receipt.creditCardPayment.holderFullName), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_39, [
                                _createVNode("div", _hoisted_40, [
                                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('receiptCreditCard.id')) + ":", 1),
                                  _createVNode("div", _hoisted_42, _toDisplayString($setup.receipt.creditCardPayment.holderIdNumber), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_43, [
                                _createVNode("div", _hoisted_44, [
                                  _createVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('receiptCreditCard.lastFourDigits')) + ":", 1),
                                  _createVNode("div", _hoisted_46, "*" + _toDisplayString($setup.receipt.creditCardPayment.lastFourDigits), 1)
                                ]),
                                _createVNode("div", _hoisted_47, [
                                  _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('receiptCreditCard.payments')) + ":", 1),
                                  _createVNode("div", _hoisted_49, _toDisplayString($setup.receipt.creditCardPayment.numberOfPayments), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.receipt.bankTransferPayment)
                        ? (_openBlock(), _createBlock("div", _hoisted_50, [
                            _createVNode("div", _hoisted_51, [
                              _createVNode("div", _hoisted_52, [
                                _createVNode("div", _hoisted_53, [
                                  _createVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('receipt.bank')) + ":", 1),
                                  _createVNode("div", _hoisted_55, _toDisplayString($setup.receipt.bankTransferPayment.bank), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_56, [
                                _createVNode("div", _hoisted_57, [
                                  _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('receipt.branch')) + ":", 1),
                                  _createVNode("div", _hoisted_59, "#" + _toDisplayString($setup.receipt.bankTransferPayment.bankBranchNumber), 1)
                                ]),
                                _createVNode("div", _hoisted_60, [
                                  _createVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('receiptBankTransfer.account')) + ":", 1),
                                  _createVNode("div", _hoisted_62, _toDisplayString($setup.receipt.bankTransferPayment.accountNumber), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_63, [
                                _createVNode("div", _hoisted_64, [
                                  _createVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('receipt.valueDate')) + ":", 1),
                                  _createVNode("div", _hoisted_66, _toDisplayString($setup.moment($setup.receipt.bankTransferPayment.valueDate, $setup.moment.ISO_8601).format('DD/MM/YYYY')), 1)
                                ]),
                                _createVNode("div", _hoisted_67, [
                                  _createVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('receiptBankTransfer.reference')) + ":", 1),
                                  _createVNode("div", _hoisted_69, _toDisplayString($setup.receipt.bankTransferPayment.referenceNumber), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.receipt.checkPayments)
                        ? (_openBlock(), _createBlock("div", _hoisted_70, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.receipt.checkPayments, (checkPayment, index) => {
                              return (_openBlock(), _createBlock("div", {
                                class: ["accounting-form", index != 0 ? 'mt-12' : ''],
                                key: index
                              }, [
                                _createVNode("div", _hoisted_71, [
                                  _createVNode("div", _hoisted_72, [
                                    _createVNode("div", _hoisted_73, [
                                      _createVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('receipt.bank')) + ":", 1),
                                      _createVNode("div", _hoisted_75, _toDisplayString(checkPayment.bank), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_76, [
                                    _createVNode("div", _hoisted_77, [
                                      _createVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('receipt.branch')) + ":", 1),
                                      _createVNode("div", _hoisted_79, "#" + _toDisplayString(checkPayment.bankBranchNumber), 1)
                                    ]),
                                    _createVNode("div", _hoisted_80, [
                                      _createVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('receiptCheck.account')) + ":", 1),
                                      _createVNode("div", _hoisted_82, _toDisplayString(checkPayment.accountNumber), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_83, [
                                    _createVNode("div", _hoisted_84, [
                                      _createVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('receiptCheck.checkNumber')) + ":", 1),
                                      _createVNode("div", _hoisted_86, _toDisplayString(checkPayment.checkNumber), 1)
                                    ]),
                                    _createVNode("div", _hoisted_87, [
                                      _createVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('receipt.valueDate')) + ":", 1),
                                      _createVNode("div", _hoisted_89, _toDisplayString($setup.moment(checkPayment.valueDate, $setup.moment.ISO_8601).format('DD/MM/YYYY')), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_90, [
                                    _createVNode("div", _hoisted_91, [
                                      _createVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('receipt.amount')) + ":", 1),
                                      _createVNode("div", _hoisted_93, _toDisplayString(checkPayment.amount) + " " + _toDisplayString($setup.getCurrencySymbol($setup.receipt.currencyId)), 1)
                                    ])
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.receipt.cashPayment)
                        ? (_openBlock(), _createBlock("div", _hoisted_94, [
                            _createVNode("div", _hoisted_95, [
                              _createVNode("div", _hoisted_96, [
                                _createVNode("div", _hoisted_97, _toDisplayString(_ctx.$t('receipt.valueDate')) + ":", 1),
                                _createVNode("div", _hoisted_98, _toDisplayString($setup.moment($setup.receipt.cashPayment.valueDate, $setup.moment.ISO_8601).format('DD/MM/YYYY')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_99, [
      _createVNode("div", _hoisted_100, _toDisplayString(_ctx.$t('accounting.total')) + " " + _toDisplayString(_ctx.formatAmount($setup.receipt.localCurrencyTotalAmount)) + " " + _toDisplayString($setup.getCurrencySymbol($setup.receipt.currencyId)), 1),
      _createVNode("div", _hoisted_101, [
        _createVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.close())),
          class: "accounting-circle-button dark-circle-button"
        }, _toDisplayString(_ctx.$t('button.close')), 1),
        _createVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPdf())),
          class: "accounting-circle-button btn-blue"
        }, _toDisplayString(_ctx.$t('button.view-pdf')), 1),
        _hoisted_102
      ])
    ])
  ]))
})